<template>
    <div :class="fabItemClass">
        <label
            v-if="label"
            :for="uniqueId('fab-item')"
            class="fab-label"
        >
            {{ label }}
        </label>

        <rkm-button
            v-if="authorized"
            :id="uniqueId('fab-item')"
            @click="$emit('click', $event)"
            class="fab-button"
            v-bind="$props"
        >
            <rkm-icon :icon="icon"></rkm-icon>
        </rkm-button>
    </div>
</template>

<script>
import { permissao } from '@/mixins'

export default {
    computed: {
        fabItemClass() {
            return `fab-item btn-${this.color}`
        },
    },
    created() {
        this.authorized = this.verificarPermissao(this.authorize)
    },
    data: () => ({
        authorized: true
    }),
    mixins: [
        permissao
    ],
    props: {
        authorize: { type: String, default: '' },
        color: { type: String, default: 'secondary' },
        disabled: { type: Boolean, default: false },
        icon: { type: String },
        label: { type: String, default: '' },
    }
}
</script>

<style scoped>
.fab-item {
    position: relative;
    background: none !important;
    height: 59px;
    padding: 7px 0;
    white-space: nowrap;
    flex: 1 0 auto;
    align-self: flex-end;
    text-align: right;
}

.fab-button {
    border-radius: 100%;
    width: 45px;
    height: 45px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 17px;
    background: #FFF;
    position: relative;
    z-index: 2;
    color: #222;
    margin: 2px 0;
    box-shadow: 0 3px 6px rgba(0,0,0,0.10), 0 3px 6px rgba(0,0,0,0.15);
}

.fab-button:hover {
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}

.btn-primary { color: #007bff; }
.btn-success { color: #3ac47d; }
.btn-danger { color: #d92550; }
.btn-warning { color: #f7b924; }

.btn-primary .fab-label { background: #007bff; color: #FFF; }
.btn-success .fab-label { background: #3ac47d; color: #FFF; }
.btn-danger .fab-label { background: #d92550; color: #FFF; }
.btn-warning .fab-label { background: #f7b924; color: #222; }

.fab-label:hover { background: #EFEFEF;}
.btn-primary:hover .fab-label { background: #2955c8; }
.btn-success:hover .fab-label { background: #31a66a; }
.btn-danger:hover .fab-label { background: #b81f44; }
.btn-warning:hover .fab-label { background: #f7b924; }

.fab-label {
    position: relative;
    right: 0;
    white-space: nowrap;
    margin: 0px -46px 0 0;
    vertical-align: middle;
    font-weight: 500;
    font-size: 13px;
    padding: 0 calc(1rem + 50px) 0 1rem;
    height: 47px;
    display: inline-flex;
    align-items: center;
    border-radius: 100px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    color: #222;
    z-index: 1;
    cursor: pointer;
    transition: background 0.3s;
    background: #FFF;
}
</style>